import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { api } from '@/lib/api';
import { Truck, Mail, Lock, Store } from 'lucide-react';

export default function OwnerRegister() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [restaurantName, setRestaurantName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { setOwnerSession } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await api.auth.register({ email, password, restaurant_name: restaurantName });
      setOwnerSession(data);
      navigate('/owner/dashboard');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-navy-950 via-navy-900 to-navy-800 flex items-center justify-center p-4">
      <div className="w-full max-w-md animate-fade-in">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-cyan-700/20 rounded-2xl mb-4">
            <Truck className="w-8 h-8 text-cyan-400" />
          </div>
          <h1 className="text-2xl font-bold text-white">Vendox Delivery</h1>
          <p className="text-navy-300 mt-2">إنشاء حساب مطعم جديد</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-navy-800/50 backdrop-blur border border-navy-700 rounded-2xl p-6 space-y-5">
          <h2 className="text-xl font-semibold text-white text-center">تسجيل جديد</h2>

          {error && (
            <div className="bg-red-500/10 border border-red-500/30 text-red-400 text-sm rounded-lg p-3 text-center">
              {error}
            </div>
          )}

          <div className="space-y-1">
            <label className="text-sm text-navy-200">اسم المطعم</label>
            <div className="relative">
              <Store className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-navy-400" />
              <input
                type="text"
                value={restaurantName}
                onChange={e => setRestaurantName(e.target.value)}
                className="w-full bg-navy-900/80 border border-navy-600 rounded-xl pr-10 pl-4 py-3 text-white placeholder-navy-500 focus:outline-none focus:border-cyan-500 transition-colors"
                placeholder="مثال: مطعم الشرق"
                required
              />
            </div>
          </div>

          <div className="space-y-1">
            <label className="text-sm text-navy-200">البريد الإلكتروني</label>
            <div className="relative">
              <Mail className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-navy-400" />
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="w-full bg-navy-900/80 border border-navy-600 rounded-xl pr-10 pl-4 py-3 text-white placeholder-navy-500 focus:outline-none focus:border-cyan-500 transition-colors"
                placeholder="example@restaurant.com"
                required
                dir="ltr"
              />
            </div>
          </div>

          <div className="space-y-1">
            <label className="text-sm text-navy-200">كلمة المرور</label>
            <div className="relative">
              <Lock className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-navy-400" />
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="w-full bg-navy-900/80 border border-navy-600 rounded-xl pr-10 pl-4 py-3 text-white placeholder-navy-500 focus:outline-none focus:border-cyan-500 transition-colors"
                placeholder="6 أحرف على الأقل"
                required
                minLength={6}
                dir="ltr"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-cyan-600 hover:bg-cyan-700 disabled:opacity-50 text-white font-medium py-3 rounded-xl transition-colors"
          >
            {loading ? 'جاري إنشاء الحساب...' : 'إنشاء حساب'}
          </button>

          <p className="text-center text-navy-300 text-sm">
            لديك حساب؟{' '}
            <Link to="/owner/login" className="text-cyan-400 hover:text-cyan-300 transition-colors">
              تسجيل الدخول
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
